import { Fragment } from 'react';

import MyActions from '../../sections/myActions/MyActions';
import MyAccount from '../../sections/myAccount/MyAccount';
import PersonBanner from '../../sections/personBanner/PersonBanner';
import MyMemberCards from '../../sections/myMemberCards/MyMemberCards';
import MyCommunications from '../../sections/myCommunications/MyCommunications';
import MyCertifications from '../../sections/myCertifications/MyCertifications';
import DataHubLinks from '../../sections/dataHubLinks/DataHubLinks';

import style from '../../LandingPages.module.css';

const MinorIndividualLanding = () => (
  <Fragment>
    <div className="row">
      <div className="col-xs-12">
        <PersonBanner />
      </div>
    </div>
    <div className={['row', style.Dashboard].join(' ')}>
      <div className='col-xs-12 col-sm-6'>
        <MyMemberCards />
        <MyActions />
        <MyCertifications />
      </div>
      <div className='col-xs-12 col-sm-6'>
        <DataHubLinks />
        <MyAccount />
        <MyCommunications />
      </div>
    </div>
  </Fragment>
);

export default MinorIndividualLanding;